import { InfoCircleOutlined } from '@ant-design/icons'
import { Grid, Typography, Checkbox, useTheme, Tooltip } from '@mui/material'
import React, { useCallback, useMemo } from 'react'

const createStyles = (theme) => ({
  disabled: {
    '& .MuiCheckbox-root': {
      color: theme.palette.text.disabled,
      backgroundColor: theme.palette.secondary.darker,
    },
  },
  regular: {
    color: theme.palette.text.primary,
  },
})
export default function PortfolioSelect({
  name,
  isPortfolioInPortfolio = false,
  portfolio,
  parentPortfolio,
  addPortfolioToPortfolio,
  removePortfolioFromPortfolio,
}) {
  const theme = useTheme()
  const styles = createStyles(theme)

  const isPortfolioIntersected = useMemo(() => {
    if (
      parentPortfolio.portfolioIds.includes(portfolio.id) ||
      parentPortfolio.portfolioIds.length === 0
    )
      return false
    const parentPortfolioAccountsIds = parentPortfolio.accountsIds
    const portfolioAccountsIds = portfolio.accountsIds

    return parentPortfolioAccountsIds.some((id) => portfolioAccountsIds.includes(id))
  }, [
    parentPortfolio.accountsIds,
    parentPortfolio.portfolioIds,
    portfolio.accountsIds,
    portfolio.id,
  ])

  const isCircularReference = useMemo(
    () => parentPortfolio.circularReferncePath.includes(portfolio.id),
    [parentPortfolio.circularReferncePath, portfolio.id]
  )

  const onPortfolioSelected = useCallback(
    (isPortfolioChecked) => {
      if (isPortfolioChecked) {
        addPortfolioToPortfolio({
          portfolioId: parentPortfolio.id,
          portfoliosIds: [portfolio.id],
        })
      } else {
        removePortfolioFromPortfolio({
          portfolioId: parentPortfolio.id,
          portfoliosIds: [portfolio.id],
        })
      }
    },
    [addPortfolioToPortfolio, parentPortfolio.id, portfolio.id, removePortfolioFromPortfolio]
  )
  return (
    <Grid
      container
      alignItems={'center'}
      columnSpacing={0.75}
      sx={isPortfolioIntersected || isCircularReference ? styles.disabled : undefined}
    >
      <Grid item>
        <Checkbox
          edge="start"
          checked={isPortfolioInPortfolio}
          disableRipple
          disabled={isPortfolioIntersected || isCircularReference}
          onChange={(e) => {
            onPortfolioSelected(e.target.checked)
          }}
        />
      </Grid>
      <Grid item>
        <Tooltip
          placement={'right'}
          title={
            isCircularReference || isPortfolioIntersected ? (
              <>
                The selected portfolio cannot be nested under a portfolio that is already below it.
                <br />
                This would create a circular structure.
              </>
            ) : (
              ''
            )
          }
        >
          <Grid container columnSpacing={0.75} alignItems={'center'}>
            <Grid item>
              <Typography variant={'h6'} sx={{ lineHeight: 0 }}>
                {name}
              </Typography>
            </Grid>
            {isCircularReference && (
              <Grid item sx={styles.regular}>
                <InfoCircleOutlined />
              </Grid>
            )}
          </Grid>
        </Tooltip>
      </Grid>
    </Grid>
  )
}
